/*eslint-disable */
import axios from 'axios'

export function updateChatMessages (context, payload) {
  context.commit('updateMessages', payload)
}

export function updateChatMessage (context, payload) {
  context.commit('updateMessages', [payload])
}

export function sendDeleteMessage (context, msgId) {
  const url = `/centrifuge/repairer/message/${msgId}`
  axios.delete(url).then(res => {
    if (res?.data?._status) {
      context.dispatch('deleteMessage', msgId)
    }
    // console.log(res)
  }).catch(err => {
    console.log(err)
  })
}
export function deleteMessage (context, msgId) {
  // console.log('DELETE MSG ID', msgId)
  context.commit('deleteMessage', msgId)
}


